import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["defaultHidden", "isHidden", "onClick"];
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';

/**
 * withUncontrolled is a HOC that enhances ShowHide and ShowHideWordCount
 * with default prop values to handle uncontrolled use cases.
 *
 * This could be potentially extended and used across all other components
 * that need to have uncontrolled prop values.
 */
export var withUncontrolled = function withUncontrolled(Component) {
  var WithUncontrolled = function WithUncontrolled(_ref) {
    var defaultHidden = _ref.defaultHidden,
      controlledHidden = _ref.isHidden,
      onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, _excluded);
    var _useState = useState(defaultHidden),
      _useState2 = _slicedToArray(_useState, 2),
      uncontrolledHidden = _useState2[0],
      setUncontrolledHidden = _useState2[1];
    var isHidden = typeof controlledHidden !== 'undefined' ? controlledHidden : uncontrolledHidden;
    var onClickCallback = useCallback(function (nextValue) {
      setUncontrolledHidden(!nextValue);
      if (typeof onClick === 'function') {
        onClick(typeof controlledHidden !== 'undefined' ? nextValue : !nextValue);
      }
    }, [controlledHidden, onClick]);
    return /*#__PURE__*/React.createElement(Component, _extends({
      isHidden: isHidden,
      onClick: onClickCallback
    }, rest));
  };
  WithUncontrolled.displayName = "" + (Component.displayName || Component.name || 'Component');
  WithUncontrolled.Hidden = Component.Hidden || null;
  WithUncontrolled.propTypes = process.env.NODE_ENV !== "production" ? {
    defaultHidden: PropTypes.bool
  } : {};
  WithUncontrolled.defaultProps = {
    defaultHidden: true
  };
  return WithUncontrolled;
};